module.exports = __webpack_public_path__ + "static/media/hasalon_thumb.fa823428.jpg";